"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _styledMediaQuery = _interopRequireDefault(require("styled-media-query"));

var _Utils = require("../../Utils");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n        padding: ", "vh 1rem ", "vh;\n      "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n        padding: ", "vh 2rem ", "vh;\n      "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var Wrapper = _styledComponents["default"].header.withConfig({
  displayName: "Mast__Wrapper",
  componentId: "sc-182sxm6-0"
})(["background-color:#222;display:block;height:100%;position:relative;width:100%;"]);

var Container = _styledComponents["default"].div.withConfig({
  displayName: "Mast__Container",
  componentId: "sc-182sxm6-1"
})(["box-sizing:border-box;color:#fff;margin:0 auto;position:relative;text-align:center;max-width:100%;", ""], function (_ref) {
  var offset = _ref.offset,
      size = _ref.size;

  var withOffset = function withOffset(v) {
    return v + offset;
  };

  var getBase = function getBase() {
    switch (size) {
      case 'small':
        return 7;

      case 'large':
        return 32;

      case 'medium':
      default:
        return 15;
    }
  };

  var base = getBase();
  var md = base / 1.25;
  var sm = base / 2;
  return (0, _styledComponents.css)(["padding:", "vh 3rem ", "vh;", " ", ""], base, withOffset(base), _styledMediaQuery["default"].lessThan('medium')(_templateObject(), md, withOffset(md)), _styledMediaQuery["default"].lessThan('small')(_templateObject2(), sm, withOffset(sm)));
});

var Mast = function Mast(_ref2) {
  var title = _ref2.title,
      subtitle = _ref2.subtitle,
      offset = _ref2.offset,
      renderBottom = _ref2.renderBottom,
      renderTop = _ref2.renderTop,
      size = _ref2.size,
      rest = _objectWithoutProperties(_ref2, ["title", "subtitle", "offset", "renderBottom", "renderTop", "size"]);

  return /*#__PURE__*/_react["default"].createElement(Wrapper, null, /*#__PURE__*/_react["default"].createElement(_Utils.BackgroundCoverImage, rest), /*#__PURE__*/_react["default"].createElement(Container, {
    size: size,
    offset: offset
  }, renderTop, /*#__PURE__*/_react["default"].createElement(_Utils.Headline, null, title), subtitle && /*#__PURE__*/_react["default"].createElement(_Utils.Tagline, null, subtitle), renderBottom));
};

Mast.defaultProps = {
  offset: 0,
  size: 'medium',
  subtitle: '',
  renderBottom: null,
  renderTop: null
};
Mast.propTypes = {
  title: _propTypes["default"].string.isRequired,
  subtitle: _propTypes["default"].string,
  size: _propTypes["default"].oneOf(['small', 'medium', 'large']),
  offset: _propTypes["default"].number,
  renderBottom: _propTypes["default"].node,
  renderTop: _propTypes["default"].node
};
var _default = Mast;
exports["default"] = _default;